import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router";

import { featureFlagsEnums, loginConstants } from "./constants";
import { useSignalR, getItemFromStorage } from "./system";
import { getHubElements } from "./system/hubElements";
import { isGroupAdmin, isSuperOrBrandAdmin } from "./shared";
import { loginActions } from "./redux/actions";
import useSignalRListeners from "./shared/components/hooks/useSignalRListner/useSignalRListner";
import { featureFlagsTabs } from "./views/admin-screens/constants";
import AppRoutes from "./app/appShell/appRoutes";
import AppModeInitializer from "./app/appShell/appModeInitializer";
import BrowserHistoryGuard from "./app/appShell/browserHistoryGuard";
import AuthenticationRouter from "./app/appShell/authenticationRouter";

const App = (props) => {
  const {
    getBrandsWithFeatureFlags,
    authentication: { isAuthenticated, user },
  } = props;

  const signalRContext = useSignalR();

  const navigate = useNavigate();
  const location = useLocation();
  const localStorageBrandId = getItemFromStorage(loginConstants.BRAND_ID);
  const localStorageGroupId = getItemFromStorage(loginConstants.GROUP_ID);
  const localStorageManagerId = getItemFromStorage(loginConstants.MANAGER_ID);

  const onInboxDisable = (data, features) => {
    const currentPath = location.pathname;
    const isInboxActive = features.includes(featureFlagsEnums.INBOX);

    if (currentPath.includes(featureFlagsTabs.inboxPath) && !isInboxActive) {
      if (
        isSuperOrBrandAdmin() &&
        Number(localStorageBrandId) === data.brandId
      ) {
        navigate(`/stores/dashboard/${localStorageBrandId}`, {
          replace: true,
        });
      }
      if (!isSuperOrBrandAdmin() && user.brandId === data.brandId) {
        navigate(
          `/dashboard/${
            isGroupAdmin() ? localStorageGroupId : localStorageManagerId
          }`,
          { replace: true }
        );
      }
    }
  };

  const { hubRootElement, hubImagePathElement } = getHubElements();

  useSignalRListeners(
    signalRContext,
    user,
    getBrandsWithFeatureFlags,
    onInboxDisable
  );

  return (
    <div className="react-app">
      <AppRoutes
        isAuthenticated={isAuthenticated}
        isHubMode={Boolean(hubRootElement && hubImagePathElement)}
      />
      <ToastContainer />
      {/* Keep this order: their start-up effects must run in this sequence. */}
      <BrowserHistoryGuard />
      <AppModeInitializer
        hubRootElement={hubRootElement}
        hubImagePathElement={hubImagePathElement}
      />
      <AuthenticationRouter />
    </div>
  );
};

const mapStateToProps = (state) => ({
  authentication: state.authentication,
  frRoute: state.individualStoreProfileReducer.frRoute,
});
// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getBrandsWithFeatureFlags: (data) =>
    dispatch(loginActions.getBrandsWithFeatureFlags(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
